module.exports = __webpack_public_path__ + "images/finishes-9cf0d623cfbf31f66685d0445b0ab62a.jpg";